import * as Routes from 'Routes';
import { navigate } from 'gatsby';
import { useEffect, useState } from 'react';

import trackings from 'utils/trackings';

import { createSpacingDiv } from './helpers';

const useAnchorButton = ({ scrollRef, eventName, pageName, customLink }) => {
  const [isVisible, setIsVisible] = useState(false);

  const { pageInteraction } = trackings;

  const handleClick = () => {
    pageInteraction({ pageName, eventName });

    if (customLink) {
      window.location.href = customLink;
    } else {
      navigate(Routes.document.path);
    }
  };

  const showButton = (entries) => {
    if (!entries[0].isIntersecting) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    const $formStarter = document.querySelector(`.${scrollRef}`);
    const observer = new IntersectionObserver(showButton, {
      threshold: 0.3,
    });

    observer.observe($formStarter);

    return () => observer.unobserve($formStarter);
  }, [scrollRef]);

  const showSpacing = () => {
    const $spacingElement = document?.querySelector('#anchor-button-spacing');
    const showSpacing = isVisible && !$spacingElement;
    const removeSpacing = !isVisible && $spacingElement;

    if (showSpacing) createSpacingDiv();

    if (removeSpacing) $spacingElement?.remove();
  };

  useEffect(showSpacing, [isVisible]);

  return { isVisible, handleClick };
};

export default useAnchorButton;
